import { useRunGroupedBodyAction } from "./context-menu-actions/history";
import { useInspectContextMenuTarget } from "./context-menu-actions/inspect";
import { useAddDuplicateActions } from "./context-menu-actions/addDuplicateActions";
import { useBodyContextMenuActions } from "./context-menu-actions/bodyActions";
import { useMeshGeomSiteContextMenuActions } from "./context-menu-actions/meshGeomSiteActions";
import { useCameraInertialContextMenuActions } from "./context-menu-actions/cameraInertialActions";
import { useJointContextMenuActions } from "./context-menu-actions/jointActions";

/**
 * Composes every "menu item clicked -> mutate the scene" callback for the
 * scene graph context menu. The implementation is split by entity family so
 * each smaller hook owns one behavioral area while this module preserves the
 * existing import surface for SceneGraphDiagram.
 */
export function useSceneGraphContextMenuActions({
  isPhysicsRunning,
  bodies,
  joints,
  equalities,
  tendons,
  cameras,
  worldBodies,
  bodyDepthMap,
  worldRootTargetBodyUuid,
  sceneActions,
  closeContextMenu,
  clearBatchSelection,
  contextMenuType,
  contextMenuBodyUuid,
  contextMenuBodyUuids,
  contextMenuMeshIds,
  contextMenuGeomKeys,
  contextMenuSiteIds,
  contextMenuInertialKeys,
  contextMenuJointIds,
  contextMenuCameraIds,
}) {
  const runGroupedBodyAction = useRunGroupedBodyAction();

  const inspectContextMenuTarget = useInspectContextMenuTarget({
    closeContextMenu,
    contextMenuType,
    contextMenuBodyUuid,
    contextMenuBodyUuids,
    contextMenuMeshIds,
    contextMenuGeomKeys,
    contextMenuSiteIds,
    contextMenuInertialKeys,
    contextMenuJointIds,
    contextMenuCameraIds,
  });

  const addDuplicateActions = useAddDuplicateActions({
    isPhysicsRunning,
    bodies,
    joints,
    equalities,
    tendons,
    cameras,
    worldRootTargetBodyUuid,
    sceneActions,
    closeContextMenu,
  });

  const bodyActions = useBodyContextMenuActions({
    isPhysicsRunning,
    bodies,
    worldBodies,
    bodyDepthMap,
    sceneActions,
    clearBatchSelection,
    runGroupedBodyAction,
  });

  const meshGeomSiteActions = useMeshGeomSiteContextMenuActions({
    bodies,
    contextMenuMeshIds,
    contextMenuGeomKeys,
    contextMenuSiteIds,
    sceneActions,
    clearBatchSelection,
    runGroupedBodyAction,
  });

  const cameraInertialActions = useCameraInertialContextMenuActions({
    contextMenuCameraIds,
    contextMenuInertialKeys,
    sceneActions,
    clearBatchSelection,
    runGroupedBodyAction,
  });

  const jointActions = useJointContextMenuActions({
    isPhysicsRunning,
    bodies,
    joints,
    contextMenuJointIds,
    sceneActions,
    clearBatchSelection,
    runGroupedBodyAction,
  });

  return {
    runGroupedBodyAction,
    inspectContextMenuTarget,
    ...addDuplicateActions,
    ...bodyActions,
    ...meshGeomSiteActions,
    ...cameraInertialActions,
    ...jointActions,
  };
}
